<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 3s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes ww-1 {
    0%,
    20% {
      opacity: 1;
    }
    20%,
    100% {
      opacity: 0;
    }
  }
  #ww-1 {
    animation-name: ww-1;
  }
  @keyframes ww-2 {
    0%,
    20% {
      opacity: 0;
    }
    20%,
    40% {
      opacity: 1;
    }
    40%,
    100% {
      opacity: 0;
    }
  }
  #ww-2 {
    animation-name: ww-2;
  }
  @keyframes ww-3 {
    0%,
    40% {
      opacity: 0;
    }
    40%,
    60% {
      opacity: 1;
    }
    60%,
    100% {
      opacity: 0;
    }
  }
  #ww-3 {
    animation-name: ww-3;
  }
  @keyframes ww-4 {
    0%,
    60% {
      opacity: 0;
    }
    60%,
    80% {
      opacity: 1;
    }
    80%,
    100% {
      opacity: 0;
    }
  }
  #ww-4 {
    animation-name: ww-4;
  }
  @keyframes ww-5 {
    0%,
    80% {
      opacity: 0;
    }
    80%,
    100% {
      opacity: 1;
    }
  }
  #ww-5 {
    animation-name: ww-5;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 853.2 728.8" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="ww-1">
      <path
        fill="var(--pants)"
        d="m157 338 8-2c1 6 2 13 5 18a31 31 0 0 1 5 29c-3 9 6 14 6 22 0 1 3 2 4 0 3-5 3 2 5 1-3 13-1 26-3 39l-1 10c-2 13-2 13-15 15l-58 3c-13-2-13-2-13-14 0-27-3-53-12-78-4-12-5-25-4-37 7 6 14 5 22 3 11-3 21-6 32-6h9c5 2 7 0 10-3Z"
      />
      <path fill="var(--shirt)" d="M177 303Z" />
      <path fill="var(--hair)" d="M114 80Z" />
      <path
        fill="var(--hair)"
        d="M200 678c3-2 5-5 3-8-1-4-3-6-7-6s-8-2-12-4a197 197 0 0 1-29-17c-4-3-7-5-7-10 0-2-1-7-5-3a3 3 0 0 1-2-1c-2 1-2 3-3 5 2 5 0 8-5 10 0 3 0 6-2 9-4 3-9 4-12 11-4 8-14 5-19-6l-4-7v1c-2-1-4-1-3-4 0-2 1-3 3-3a1 1 0 0 1 1 0c-1-1-1-4-4-3-2 1-3 3-3 5 0 5-1 11 1 17v3l1 8a6 6 0 0 0 1-1 6 6 0 0 1-1 2c1 4-2 8 1 12a3 3 0 0 0 2 3c6 4 12 5 19 6a3 3 0 0 0 3 1h4l9 3 2 1 12 6 4 1c7 2 14 1 21 0 9-1 17-3 25-8 6-4 8-11 4-16-3-4-1-5 2-7Zm-107-7a6 6 0 0 0 0-1 6 6 0 0 1 0 1Zm0 3a3 3 0 0 0 1-1 3 3 0 0 1 0 1Z"
      />
      <path fill="var(--shirt)" d="M192 334ZM194 335Z" />
      <path
        fill="var(--pants)"
        d="M157 338c-3 3-5 5-10 3h-9c7-2 13-4 19-3Z"
      />
      <path
        fill="var(--hair)"
        d="M184 5c-2-5-7-3-11-3-3 0-7 1-10-2h-30c-3 4-8 3-13 4-15 3-24 14-23 30s4 31 9 46a5 5 0 0 0 1 6c4-1 6-2 7-5 8-7 2-15 1-22-1-6 0-9 4-13 7-1 11 2 13 8 2 8 6 9 12 3a17 17 0 0 0 2-3 15 15 0 0 1-1-2l1 2 2-4c1-6 3-11 9-14 4-2 4-6 4-9-2-8 1-11 9-8l8 4 2-3a28 28 0 0 0 2-3c2-4 5-8 2-12Z"
      />
      <path
        fill="var(--hair)"
        d="M96 652c-2-1-3-1-3-4 0-2 1-3 3-3v2h-1a7 7 0 0 0 1 1v2Z"
      />
      <path fill="var(--pants)" d="M96 650v-2l1 1a8 8 0 0 0-1 1Z" />
      <path
        fill="var(--pants)"
        d="M96 648a7 7 0 0 1-1-1h1a1 1 0 0 1 0 1Z"
      />
      <path
        fill="var(--shirt)"
        d="M191 312c-7-37-8-74-6-111 1-10 0-20-5-29-2-10-6-18-11-26-1-5-4-8-6-11a40 40 0 0 0-9-14c0-2-1-3-3-4-3 1-2 3-2 6-1 6-3 8-8 5-3-2-6-2-10-2-5-7-12-9-20-11l-9-13c-8 6-9 16-14 24-4 7-5 15-11 21v29a192 192 0 0 1 13 90c-2 11-1 23-5 33-6 15-3 30-1 45 7 6 14 5 22 3 11-3 21-6 32-6 7-2 13-4 19-3l8-2a18 18 0 0 0-6-11c-9-9-15-20-25-28-7-6-11-16-14-26-1-3-4-6-3-11-1 0-2 3-2 0v-17l1-1c-4-3-2-7-3-11-3-8-6-16-5-25-5-2-1-6-2-9a46 46 0 0 1 0-13c12 4 24 1 36 2 2 0 6-1 7 3a7 7 0 0 0 1 0 7 7 0 0 1-1 0l-1 35c0 5 1 10 4 14l7 19c2 3 5 7 4 12 4 0 1 5 4 6l1 3 1 5c4 4 5 9 5 14 4 1 3 4 3 6 2 0 3 1 3 3v3c5 2 4 8 6 12 1 3 1 7 6 8 2-6 0-11-1-17Zm-38-115-1-1v-1l2 1-1 1Zm10-11a3 3 0 0 0-1-2 3 3 0 0 1 1 2Zm-1 20a99 99 0 0 1 2 15 99 99 0 0 0-2-15Zm6 65a21 21 0 0 0 1-3 21 21 0 0 1-1 3Z"
      />
      <path d="m152 195 2 1-1 1-1-1Z" fill="var(--shirt)" />
      <path
        fill="var(--flesh)"
        d="m194 335-2-1v-5c-5-1-5-5-6-8-2-4-1-9-6-12v-3a2 2 0 0 1-3-2 2 2 0 0 0 3 2c0-2-1-3-3-3 0-2 1-5-3-6v6a4 4 0 0 0-2 2 4 4 0 0 1 2-2v-6c0-5-1-10-5-14l-1-5-1-3c-3-1 0-6-4-6 1-5-2-9-4-12l-7-19c-3-4-4-9-4-14l1-35c-1-4-5-3-7-3-12-1-24 2-36-2a46 46 0 0 0 0 14c1 2-3 6 2 8-1 9 2 17 5 25 1 4-1 8 3 11l-1 1v18c0 2 1-1 2 0-1 4 2 7 3 10 3 10 7 20 14 26 10 8 16 19 25 28a18 18 0 0 1 6 11c1 6 2 13 5 18a31 31 0 0 1 5 29c-3 9 6 14 6 22 0 1 3 2 4 0 3-5 3 2 5 2 7 0 6-7 9-10 2 2 0 6 3 6s3-3 4-6l4-13c1-10 1-21-5-30l-11-19ZM103 520a58 58 0 0 0-5 9c-4 8-8 17-8 27l5 51c1 13 3 25 2 38a1 1 0 0 0-1 0v2a1 1 0 0 1 0 1l1 1a10 10 0 0 0-1 1v2l3 7c6 10 16 13 20 5 3-7 8-8 12-11 2-3 2-6 2-9 5-2 7-5 5-10 1-2 1-4 3-4v-9l-1-4c2-15-1-30 0-44v-6c2-2 1-4 1-7 2-11 1-23 7-32 12-18 17-38 23-58-19 0-39 3-59 3 3 16 0 32-9 47Zm-3 138v-2 2Zm37-31a9 9 0 0 0 0 2 5 5 0 0 0 0 1 5 5 0 0 1 0-1 9 9 0 0 1 0-2 12 12 0 0 1 1-1 12 12 0 0 0-1 1Zm6-95-2-5 2 5Zm-2-5a6 6 0 0 0-3 0 6 6 0 0 1 3 0ZM96 648ZM107 86c-2 5-1 11-5 16l9 13c7 2 15 4 20 11 4 0 7 0 10 2 5 3 7 1 8-5 0-2-1-5 2-6-2-11 5-18 16-16 4 0 11 1 12-4 1-8 8-14 7-22a5 5 0 0 1 1-4c4-4 3-8 0-12-2-3-6-6-5-9 2-10-3-18-4-27l-8-4c-8-3-11 0-9 8 0 3 0 8-4 9-6 3-8 8-9 14l-2 4a16 16 0 0 1-2 3c-6 6-10 5-12-3-2-6-6-9-13-8-5 4-5 8-4 13 1 7 7 15-1 22-1 3-3 4-7 5Z"
      />
    </g>
    <g id="ww-5">
      <path
        fill="var(--flesh)"
        d="M722 576c2 6 6 11 12 13 10 4 15 11 21 18l14 16 8 4a15 15 0 0 1 6 3c1 2 2 3-1 4-2 0-1 1 0 2 5 6 10 9 18 9 7 0 14-1 21 1l26 8c3 0 3 4 6 4v2c-8 8-17 4-26 3a35 35 0 0 0-9 0 77 77 0 0 1-27-2c-6-1-11-4-16-8l-23-16c-3-3-7-3-11-2-6 1-10 0-14-5-3-4-8-6-13-9l-47-28c-3-3-7-5-11-6 4 2 6-2 9-4 1-1 0-2-1-2l-4-3c-1-2-2-5-6-5l-6-5c-1-2 0-4 3-5 6-2 10-2 14 4l8 9c2 3 6 5 9 2 7-7 15-12 20-21a5 5 0 0 1 3-3l10 13c2 3 3 7 7 9Zm-13 23-12-8c3 8 6 10 12 8Z"
      />
      <path
        fill="var(--shirt)"
        d="M705 554a5 5 0 0 0-3 3c-5 9-13 14-20 21-3 3-7 1-9-2l-8-9c-4-6-8-6-14-4-3 1-4 3-3 5 2 2 3 4 6 5 4 0 5 3 6 5s2 3 4 3 2 1 1 2c-3 2-5 6-9 4-3-1-5-4-7-6l-14-12-5-1c-20 3-39 7-59 9-16 2-31 6-47 9a83 83 0 0 0-12 4c-5 2-8 1-10-4l-2-6a12 12 0 0 0 0-3l-13-52c-2-8-5-15-5-23a28 28 0 0 1 12 1c5 2 10-1 14-2 6-2 12-4 18-4 3 0 5 0 7-2h7c14-4 28-5 42-7h39a77 77 0 0 1 19 3 54 54 0 0 0 12 3c7 0 13 3 17 9l6 8c2 3 6 5 9 5l-1 1 7 11c5 3 8 8 10 13a15 15 0 0 0 3 6c2 2 3 4 2 7Z"
      />
      <path
        fill="var(--flesh)"
        d="M180 619c12-1 23-5 35-9a3 3 0 0 0 3-2c5 0 10-3 15-4 6-2 6-3 2-7-6-6-7-12-3-20a8 8 0 0 0 2-4c16 0 31-4 46-8l26-5c9-1 17-1 25 1 16 5 29 1 43-5a22 22 0 0 1 8-3c1 2 1 5 3 7s1 4-1 4c-2 1-2 3-2 5l2 21c1 9 1 17 5 25l-14 3a96 96 0 0 0-13 3c-6 3-12 2-19 3-10 3-19 2-29 1-8-1-14 2-21 4-10 3-21 4-32 6-13 2-26 1-39 4-8 2-15 5-22 9l-4 2c-3-2-6-1-8 2-1 1-2 2-3 1-3-4-8-4-12-7-6-6-7-13-2-19l9-8Zm84-27a29 29 0 0 0-16 3s-2 0-1 2a2 2 0 0 0 3 1l14-6Z"
      />
      <path
        fill="var(--pants)"
        d="M389 615c-4-8-4-16-5-25l-2-21c0-2 0-4 2-5 2 0 3-2 1-4s-2-5-3-7c0-3 1-4 4-5 13-3 25-9 38-14a8 8 0 0 0 4-4c4-7 11-12 18-16l27-12a13 13 0 0 1 9 0c0 8 3 15 5 23l13 52a12 12 0 0 1 0 3l-13 10c-9 8-19 13-31 14l-27 4c-11 2-21 7-31 12-5 3-5 3-7-2l-2-3Z"
      />
      <path
        fill="var(--hair)"
        d="m180 619-9 8c-5 6-4 13 2 19 4 3 9 3 12 7 1 1 2 0 3-1 2-3 5-4 8-2 1 1 2 3 0 5-5 5-6 11-6 18a19 19 0 0 1 0 4c0 11 5 12 14 13 8 0 11 5 9 11a6 6 0 0 1-4 4c-13 3-25 4-38 1-9-2-14-9-17-17l-17-47a29 29 0 0 1-1-13c1-1 1-3 3-3 2 1 4-1 6-2a24 24 0 0 1 8-3l25-4c1 0 3 0 2 2ZM705 554c1-3 0-5-2-7a15 15 0 0 1-3-6c-2-5-4-10-10-13l-7-11 1-1a6 6 0 0 0 2 1c12-1 22 5 32 10 8 4 14 15 12 23-2 9-3 18-8 26-4-2-5-6-7-9l-10-13ZM234 573a8 8 0 0 1-2 4c-4 8-3 14 3 20 4 4 4 5-2 7-5 1-10 4-15 4-5-8-10-17-13-27l-1-4c0-2 0-4 3-3l3 1c8-5 16-3 24-2Z"
      />
      <path
        fill="var(--flesh)"
        d="m699 568 5-8a1 1 0 0 1 1-1l2 1 4 7c-4-1-8 0-12 1Z"
      />
      <path fill="var(--hair)" d="M709 599c-6 2-9 0-12-8Z" />
    </g>
    <g id="ww-3">
      <path
        fill="var(--pants)"
        d="m29 517 5-16 12 3c9 0 18-3 26-7s16-5 24-2c5 2 9 4 14 4l26 5-8 8c-9 11-14 25-18 39-1 6-4 12-8 18-3 5-8 5-14 3l-22-6c-19-6-31-18-36-37a5 5 0 0 0-1-1Z"
      />
      <path
        fill="var(--shirt)"
        d="m136 504-26-5c-5 0-9-2-14-4-8-3-16-2-24 2s-17 7-26 7c-5 0-8-2-12-3a38 38 0 0 1 13-18l51-38c10-8 21-15 33-20 9-4 18-7 28-9 11-3 23-7 35-9l19-3 3 2 4 3a125 125 0 0 0 8 19c3 5 5 10 10 14 0 4 2 6 3 10s2 9 0 14l-13 31a21 21 0 0 0-1 5c-1 7-3 10-11 10h-3c-2-1-1-3-1-4 0-3-1-6-4-6l-7-4c-5-3-5-3-5 3-2 0-1 1-1 2l-1 8-3 1c-6 1-11-2-16-2-4 1-8-1-11-2-9-2-19-4-28-4Z"
      />
      <path
        fill="var(--hair)"
        d="M217 400c-2-1-3-3-2-5a20 20 0 0 0 1-7c0-12 6-22 11-32s17-15 28-13l16 4a17 17 0 0 1 6 3l12 6 16 8c3 2 3 5 2 8-3 5-7 6-11 8l-7-5c-6-3-9-1-9 6-1 4-2 7-6 8-5 1-7 4-8 9a27 27 0 0 1-1 2c-1 3-3 3-5 2s-3-2-2-4a14 14 0 0 0 1-5c0-4-1-7-4-8s-6-1-9 1c-4 3-6 7-8 12s-5 6-10 6l-11-4Z"
      />
      <path
        fill="var(--flesh)"
        d="m217 400 11 4c5 0 8-1 10-6s4-9 8-12c3-2 6-3 9-1s4 4 4 8a14 14 0 0 1-1 5c-1 2 0 3 2 4s4 1 5-2a27 27 0 0 0 1-2c1-5 3-8 8-9 4-1 5-4 6-8 0-7 3-9 9-6l7 6-2 8c-1 5-2 10-5 13-2 3-2 5-1 8l1 6c1 4-1 6-5 7l-3 1c0 4-3 6-4 9-5 1-7 6-10 9-2 2-5 0-8 0a13 13 0 0 1-4-2c-7-4-7-4-14 1a7 7 0 0 1-3 1l-10-14a125 125 0 0 1-8-19l-4-3-2-2c0-2 1-3 3-4Z"
      />
      <path
        fill="var(--hair)"
        d="m118 661 2 7c5 10 18 12 27 5 1-1 2-2 1-4a23 23 0 0 1 1-3 3 3 0 0 1 3-2c2 0 1 1 1 2 0 4 2 7 5 9a128 128 0 0 0 23 12l17 8c3 1 6 2 6 6s-3 5-5 6c-6 4-13 5-21 5-14 0-28-3-42-7l-22-5a28 28 0 0 1-7-3c-2-2-4-3-2-6 1-4 0-8 2-12l4-11a10 10 0 0 0 3-6v-2c2-1 3 0 4 1ZM212 639c-9-1-18-2-25-9-2-2-2-3 0-5l13 3 10 4c3 2 4 4 2 7ZM150 649c3-7 9-13 15-19l-2 16c0 2-1 2-2 2Z"
      />
      <path
        fill="var(--flesh)"
        d="M228 681c-3-3-5-7-9-8a129 129 0 0 1-19-8c-2-1-5-3-5-5a15 15 0 0 0-3-8v-2h2c5 1 9 3 14 3 6 1 12 4 17-2 2-3 3-4 0-5l-7-2c-1-1-4-1-1-3 1-1 0-2-1-2h-4c-9-1-18-2-25-9-1-2-2-3 0-5-1-6 1-12 2-18 0-5 3-10 5-15 5-11 9-21 16-31 7-8 10-19 4-30-3-6-1-11-2-17l1-2c-2-1-1-3-1-4 0-3-1-6-4-7l-7-3c-5-3-5-3-5 3l-1 2-1 8-3 1c-6 1-11-2-16-2-4 1-8-1-11-2-9-2-19-4-28-4l-8 8c-9 11-14 25-18 39-1 6-4 12-8 18 12 1 24 0 35-4l22-8h1-1l-1 2c-6 6-10 13-13 22l-10 36c-1 6-4 11-4 17-2 1-2 2-2 3l-4 12c-2 4-4 9-7 12l2 7c5 10 18 12 27 5 1-1 2-2 1-4l-1-1c-4-5-2-15 3-19 3-7 9-13 15-19l-2 16c0 2-1 2-2 2a6 6 0 0 1 1 5 17 17 0 0 0 4 12c3 4 8 6 14 8s10 3 13 8a20 20 0 0 0 11 7c4 2 5 1 6-4l5 4h4c2-4 5-3 8-4 2 0 2-2 1-3Z"
      />
    </g>
    <g id="ww-2">
      <path
        fill="var(--hair)"
        d="M173 719c-6-3-12-2-19-4l-47-11a28 28 0 0 1-7-3c-3-2-4-5-3-9l2-11a41 41 0 0 1 6-15 14 14 0 0 0 3-8c0-1-1-2 1-3l3 2a19 19 0 0 1 2 4l-1 1a5 5 0 0 0 0 1c0 7 9 16 15 16h7l12-4c6-3 5-9 4-14 2-1 4-2 4 2-1 6 3 9 8 12a160 160 0 0 0 26 14l19 8a32 32 0 0 1 5 3c5 3 5 7 1 11s-11 6-17 7l-3 1h-4a10 10 0 0 0-10 0Z"
      />
      <path fill="var(--pants)" d="M180 719a10 10 0 0 1 10 0Z" />
      <path fill="var(--shirt)" d="M24 436ZM183 320Z" />
      <path
        fill="var(--hair)"
        d="M151 293c-2-7-6-12-10-18a16 16 0 0 1-2-7l-2-16c-1-15 8-27 23-31 13-3 27-3 40-2l17 1c5 0 7 3 6 8 0 5-3 8-6 12a27 27 0 0 0-10-2c-6 0-9 4-6 9 1 4 2 8-1 10-5 5-5 10-5 16 1 4-2 6-5 5s-1-4-3-5a5 5 0 0 0-1-4 8 8 0 0 0-8-6c-4-1-6 2-8 5a30 30 0 0 0-3 14c0 4 1 8-2 11h-12Z"
      />
      <path
        fill="var(--hair)"
        d="m180 598 7 2 1 2 1-2 14 4c3 2 5 3 5 7s-2 4-5 6c-9 4-18 4-27 4l-5-1a14 14 0 0 1 2-7c2-3 5-6 4-11 3 1 4 0 3-3v-1Z"
      />
      <path
        fill="var(--hair)"
        d="m113 662 3 6c6 11 15 10 25 7 5-2 9-4 8-11l1-3a1 1 0 0 1 1 0c1 5 2 11-4 14l-12 4h-7c-6 0-15-9-15-16a5 5 0 0 1 0-1ZM177 602c1 5-2 8-4 11a14 14 0 0 0-2 7h-3c1-2 0-2-2-2a91 91 0 0 1 11-16ZM189 600l-1 2-1-2ZM164 620l2-2 1 2Z"
      />
      <path fill="var(--hair)" d="m167 620-1-2c2 0 3 0 2 2Z" />
      <path
        fill="var(--hair)"
        d="m128 622-2 5c-12 0-15-4-10-15 2-7 6-15 14-18 0 3 4 2 5 4a1 1 0 0 0 0 1l-4 13Z"
      />
      <path
        fill="var(--shirt)"
        d="M232 371c0-3-5-5-5-9l-14-20c-4-6-8-11-16-14l-5-4c-3-2-5-4-9-4a26 26 0 0 0-10-8h-2c-3-4-8-6-10-10h-12a20 20 0 0 1-8 6 244 244 0 0 0-45 44l-19 28a1 1 0 0 1-1 1 3 3 0 0 1-1 3 1 1 0 0 1-1 1 2 2 0 0 1 0 1 2 2 0 0 0 0-1 2 2 0 0 0-2 2l-1 1c0 2-2 3-4 5l-10 9a39 39 0 0 1-13 13 20 20 0 0 0-8 8 8 8 0 0 1 0 5 8 8 0 0 0 0-5l-3 2-1 4c-2 3-4 5-8 7l-2 4h-2l-7 9a11 11 0 0 0 3-1 11 11 0 0 1-3 1 5 5 0 0 0-4 5l13 7a34 34 0 0 0 7 6c3 2 7 2 9 5 14 2 27-3 40-7a1 1 0 0 1 1 0l2-2 5-2a3 3 0 0 1 5 2l4-1a17 17 0 0 1 15-1c4 2 8 0 10-4a1 1 0 0 0 1 0 7 7 0 0 1 0-2 7 7 0 0 0 0 2l18-11a9 9 0 0 1 1-1l17-18c10-7 17-18 23-29 2-3 3-3 7-1 7 4 7 4 13-2l19-10c2-1 4-4 6-4 0-3 1-5 4-5 0-2 1-3 3-5ZM74 463h-1 1Zm-1-77a1 1 0 0 0 1 0 1 1 0 0 1-1 0Zm-2 76Zm2 1a4 4 0 0 1-1 0 4 4 0 0 0 1 0Zm-1 0Zm0 0a3 3 0 0 1-1 0 3 3 0 0 0 1 0Zm-4 1h-1 1Zm-1-1a4 4 0 0 0-1 0 4 4 0 0 1 1 0Zm0 1v-1 1Zm1 1a2 2 0 0 1-1 0 2 2 0 0 0 1 0Zm-1 0Zm0 0h-1Zm-1-2Zm-6 3a2 2 0 0 1 2-1 2 2 0 0 0-2 1Zm7 1a12 12 0 0 0 6-2 12 12 0 0 1-6 2Zm13-4h-5 5l7-4-7 4Zm16-5a8 8 0 0 1 4-1 8 8 0 0 0-4 1Zm49-23 3-2a9 9 0 0 1-3 2Z"
      />
      <path fill="var(--hair)" d="M180 599c1 3 0 4-3 3l1-3Z" />
      <path
        d="m139 446-18 11a1 1 0 0 1-1 0c-2 4-6 6-10 4a17 17 0 0 0-15 1l-4 1a3 3 0 0 0-5-2l-5 2-2 2 3 1-1 1c-1 0-2 0-3-2-13 4-26 9-40 7a6 6 0 0 1 2 3 6 6 0 0 0-2-3 19 19 0 0 1-8 1 19 19 0 0 0 8-1c-2-3-6-3-9-5a34 34 0 0 1-7-6l-13-7c-5 4-6 11-9 16v21l1 3c2 14 11 21 23 27a5 5 0 0 0 1 1c20 11 42 19 63 29 2 1 3 1 5-1a57 57 0 0 0 10-12l10-31v-2l3-6c6-13 12-25 24-32-1-2-2-2-4-2s-2-1-1-3c3-3 5-8 10-10 0-2 1-2 2-3-2-3-6-2-8-3Zm-98 34Zm4 1Zm1 0Zm36-11-2 1 2-1Zm8 0a3 3 0 0 0 0-1 3 3 0 0 1 0 1Zm0-1a4 4 0 0 0-1-2 3 3 0 0 1 0-2 3 3 0 0 0 0 2 4 4 0 0 1 1 2Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--pants)"
        d="m79 465 3 1-1 1c-1 0-2 0-3-2a1 1 0 0 1 1 0Z"
      />
      <path
        fill="var(--flesh)"
        d="M297 314c-3-2-5-7-10-4l-4-2c-4-3-9-4-11-2-4 3-10 3-10 10a28 28 0 0 1-2-4c-1-1-1-3-3-2l-2 2c-2 9-3 17 1 26 1 3 3 6 6 6l3 3c6 3 6 8 5 15-1 5-3 9-2 14a18 18 0 0 0-5 9v1a4 4 0 0 0-3 2c-2 4-4 4-7 1-7-5-14-10-19-17l-2-1c-2 2-3 3-3 6-2-1-4 1-4 4-2 0-4 3-6 4l-19 10 21 20c9 7 18 15 29 20l8 5a10 10 0 0 0 6 2c3 2 6 1 10 1l5-1a7 7 0 0 0 6-4 3 3 0 0 0 2-3c2-2 2-4 2-7v-3a1 1 0 0 0 1 0v-14l1-2 1-16v-24l2-8 1-4c0-4 0-8 2-10v-3c1-6 1-13 3-19a14 14 0 0 0-1-9l-2-2Zm-5 24v-1 1Zm0 5v-3 3Zm-20 50a3 3 0 0 0 0-1 3 3 0 0 1 0 1Zm0-5Zm-9-44Zm-19 45v1ZM213 491l-4-3a2 2 0 0 0-2-2 5 5 0 0 1-3 1 5 5 0 0 0 3-1c-5-1-6-4-5-9l2-4c4-8-7-19-15-20l-42-4c-1 1-2 1-2 3-5 2-7 7-10 10-1 2 0 3 2 3l4 2c-13 7-19 19-25 32l-3 6v2l-10 31c12-1 25-1 37-6 3-1 4 0 3 3a80 80 0 0 0-3 15l-1 4a26 26 0 0 0-2 10h1-1v3l-4 13c-1 5-5 9-3 14 0 3 4 2 5 4a1 1 0 0 0 0 1l-4 13-2 10-3 5c-2 12-8 22-12 34l-1 1 3 6c6 11 15 10 25 7 5-2 9-4 8-11l1-3a37 37 0 0 1 2-18 116 116 0 0 1 12-23l2-2a91 91 0 0 1 11-16l1-3h-1 3v-1a20 20 0 0 1 2-4l14-27a74 74 0 0 1 11-19c3-4 7-7 7-12 4-4 5-9 6-14 2-3 2-7 2-10 0-8-1-16-9-21Zm-64-35Zm-12 133a6 6 0 0 1 0 1 5 5 0 0 1 0 1 5 5 0 0 0 0-1 6 6 0 0 0 0-1Zm2 2a4 4 0 0 0-1 0 4 4 0 0 1 1 0Zm9-135Zm-31 205Zm0 2v1-1ZM151 302h10c2 4 7 6 10 10h2a26 26 0 0 1 10 8c4 0 6 2 9 4l1-5c2-2 5-3 8-3h8c6 1 9-1 9-7 1-1 0-3 2-5 4-4 5-8 3-14 0-2 1-3 3-3 3-2 3-5 2-8a26 26 0 0 0-3-4c-3-4-6-8-4-14 1-2 0-4-1-6-1-5-3-10-3-16a27 27 0 0 0-10-1c-6 0-9 4-6 9 1 4 2 8-1 10-5 5-5 10-5 16 1 4-2 6-5 5s-1-4-3-5a5 5 0 0 0-1-4 8 8 0 0 0-8-6c-4-1-6 2-8 5a30 30 0 0 0-3 14c0 4 1 8-2 11h-12v7Zm14 0a10 10 0 0 0 2 3 10 10 0 0 1-2-3Z"
      />
      <path fill="var(--pants)" d="m81 471 1-1-2 1Z" />
    </g>
    <g id="ww-4">
      <path
        d="M549 561c-18 5-36 11-53 19-5 2-10-1-15 0-7 2-13 4-19 4-5 0-7-1-7-6a13 13 0 0 0-2-6l-3-40a13 13 0 0 0-2-7c-5-9-7-19-6-30a100 100 0 0 0 24-5 7 7 0 0 1 2 0c20-1 38-11 56-17a38 38 0 0 1 11-2c2 0 4 0 5-2h39c3 5 8 2 12 3 11 3 20 11 32 14l2 6c-3 7-3 15-5 22l-3 30c-4 9-3 19-5 28-1 5 0 10-5 14-2-4-8-4-9-4-8 4-16 0-24 2-2-1-4-2-6 0-4-1-3-4-3-6v-15c1-6-3-7-7-5l-9 3Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--hair)"
        d="m625 492-2-6c13-5 26-13 41-16v-1h11c19 4 21 21 24 36l3 24c1 8-1 11-8 9l-9-3 3-7c1-7-2-9-8-7-3 1-5 0-7-2-2-4-6-5-11-5a22 22 0 0 1-8-1c-4-1-6-2-7-6s3-4 5-5c4-3 8-6 5-11s-7-3-11-2c-7 3-13 8-21 3Z"
      />
      <path
        fill="var(--pants)"
        d="M442 495c-1 11 1 21 6 30a13 13 0 0 1 2 7l3 39a7 7 0 0 0-4 4c-5 8-13 12-21 15l-34 12a228 228 0 0 0-51 19c-4 2-6 0-8-2l-8-12c0-2 6-2 3-7-8-11-13-24-19-36a4 4 0 0 1 3-4c14-7 25-17 38-25a481 481 0 0 0 46-30c13-10 28-15 44-10Z"
      />
      <path
        fill="var(--flesh)"
        d="M311 564c6 12 11 25 19 36 3 5-3 5-3 7-7 1-14 5-21 7-11 3-23 3-35 7l-18 9-27 10c-9 2-18 3-25 9-6 4-13 7-17 14-4-1-7 4-10 4-5-1-11-2-15-5-6-4-7-9-3-15 2-2 4-5 3-8 12-2 21-9 30-15l2-3c11-4 22-9 28-20a7 7 0 0 0 6-2c10-6 22-9 31-16 17-13 35-18 55-19ZM574 584c8-2 16 2 24-2 1 0 7 0 9 4-3 31-8 62-13 93l-2 16c-1 6 0 7 6 6 3 0 9-5 7 4-1 2 2 2 4 1l21 2c7 1 10 6 14 9 3 2 0 5 0 7s-2 2-4 2c-3 0-7-4-9 2h-7c-9-2-18-2-27-2a41 41 0 0 1-11-1c-9-2-12-6-12-15v-42c0-6-1-9-8-9a36 36 0 0 1-7-1c-9-2-13-7-14-17 0-20 2-40 4-60 0-7 2-13 0-20l9-3c4-2 8-1 7 5v15c0 2-1 5 3 6l-8 42c0 4-1 8 1 11 1 5 6 5 9 5s3-4 2-6c0-18 3-35 2-52Z"
      />
      <path
        fill="var(--hair)"
        d="M159 638c1 4-1 7-3 9-4 6-3 11 3 15 4 3 10 4 15 5 3 0 6-5 10-4 2 1 1 3 0 4-6 7-2 14 0 21l3 1 18 6c6 2 6 9 1 12-12 7-25 11-39 7-10-2-16-7-20-17-3-12-10-22-15-32a51 51 0 0 1-4-9c-1-5 0-8 4-11 8-7 18-4 27-7Z"
      />
      <path
        fill="var(--flesh)"
        d="M625 492c8 5 14 0 21-3 4-1 8-3 11 2s-1 8-5 11c-2 1-6 1-5 5s3 5 7 6a22 22 0 0 0 8 1c5 0 9 1 12 5 1 2 3 3 6 2 6-2 9 0 8 7l-3 7c-7 2-13 7-22 8-3 0-6 4-9 7s-5 3-8 1l-2-2c-6 4-12-1-17 0-5 0-7-1-10-5-1-10 1-20 3-30 2-7 2-15 5-22Z"
      />
      <path
        fill="var(--hair)"
        d="M201 649c7-6 16-7 25-9-2 6 0 10 6 12a20 20 0 0 1 5 2c5 4 5 9-1 12a41 41 0 0 1-23 3 10 10 0 0 1-8-8l-4-12ZM219 601c-6 11-17 16-28 20-4-13-3-15 10-18 6-1 11-1 16-5 2-1 2 1 2 3Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>